import React, { useState, useEffect } from 'react';
import './Header.css';

interface HeaderProps {
  onRequestQuote: () => void;
}

const Header: React.FC<HeaderProps> = ({ onRequestQuote }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.classList.add('nav-open');
    } else {
      document.body.classList.remove('nav-open');
    }
    return () => { document.body.classList.remove('nav-open'); };
  }, [isMobileMenuOpen]);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navLinks = [
    { label: 'Services', id: 'services' },
    { label: 'About', id: 'about' },
    { label: 'Portfolio', id: 'portfolio' },
    { label: 'Process', id: 'process' },
  ];

  return (
    <header className={`header${isScrolled ? ' header--scrolled' : ''}`}>
      <div className="container">
        <div className="header__inner">
          <button className="header__logo" onClick={() => scrollTo('home')} aria-label="Sky3ware Studios – Home">
            <img src="/assets/images/sky3ware-logo.svg" alt="Sky3ware Studios" className="header__logo-img" />
          </button>

          <nav className={`header__nav${isMobileMenuOpen ? ' header__nav--open' : ''}`} aria-label="Main navigation">
            <ul className="header__nav-list">
              {navLinks.map(({ label, id }) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="header__nav-link">{label}</button>
                </li>
              ))}
            </ul>
          </nav>

          <div className="header__actions">
            <button className="btn btn-primary" onClick={onRequestQuote}>
              Request a Quote
            </button>
            <button
              className={`header__hamburger${isMobileMenuOpen ? ' header__hamburger--open' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
              aria-expanded={isMobileMenuOpen}
              aria-controls="mobile-menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="header__mobile-menu" id="mobile-menu">
          <ul className="header__mobile-list">
            {navLinks.map(({ label, id }) => (
              <li key={id}>
                <button onClick={() => scrollTo(id)} className="header__mobile-link">{label}</button>
              </li>
            ))}
            <li>
              <button className="btn btn-primary header__mobile-cta" onClick={() => { onRequestQuote(); setIsMobileMenuOpen(false); }}>
                Request a Quote
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
